import React from 'react'
import { SvgIcon, type SvgIconProps } from "@mui/material"

function CheckboxCheckedIcon1(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="22" height="22" fill="currentColor" />
        <path d="M11.0518 15.1885C10.0608 14.1958 9.07585 13.194 8.08182 12.2014C7.97272 12.0921 7.97272 11.91 8.08182 11.8007L9.22434 10.6562C9.33344 10.5469 9.51528 10.5469 9.62438 10.6562L11.2578 12.2924L15.4582 8.08196C15.5703 7.97268 15.7491 7.97268 15.8613 8.08196L17.0068 9.22945C17.1189 9.34177 17.1189 9.52087 17.0068 9.63016L11.4518 15.1885C11.3427 15.3008 11.1639 15.3008 11.0518 15.1885Z" fill="white" />
      </svg>
    </SvgIcon>
  )
}

export default CheckboxCheckedIcon1